<apm-select
  [(ngModel)]="selectedBrand"
  [bindValue]="bindValue"
  [searchable]="true"
  [clearable]="true"
  [multiple]="multiple"
  [items]="brands$ | async"
  (selectChange)="onBrandSelectionChange()"
  bindLabel="description"
></apm-select>
